import React from 'react';
import { Card } from 'antd';
import CountUp from 'react-countup';
// import iconMap from '@app/utils/iconMap';
import './NumberCard.less';

interface NumberCardInterface {
  title: string;
  icon: React.ReactNode;
  number: number;
  color?: string;
  countUp?: any;
  postfix?: string;
  loading?: boolean;
}

export const NumberCard: React.FC<NumberCardInterface> = ({
  icon,
  title,
  number,
  color = '@primary-color',
  countUp = {},
  postfix,
  loading
}) => {
  return (
    <Card className="numberCard" bordered={false} bodyStyle={{ padding: 10 }} loading={loading}>
      <span className="iconWarp">{icon}</span>
      <div className="content">
        <p className="title">{title || 'No Title'}</p>
        <p className="number">
          <CountUp start={0} end={number} duration={2.75} useEasing useGrouping separator="," {...(countUp || {})} />{' '}
          {postfix || ''}
        </p>
      </div>
    </Card>
  );
};
